import { useValidate } from "formvalidation/hooks";
import React, { useRef } from "react";
import { Message } from "components/Atoms/Message";
import { isFlightDesignatorValid } from "shared/utils/flightUtils";
import { InputBase } from "components/Atoms/formInputs/InputBase";
import { saveOrCancel } from "utilities/inputUtils";

interface Props {
  value: string
  validatorKey: string
  placeholderAirline?: string
  onChange: (value: string) => void
  focusOnMount?: boolean
  onEsc?: () => void
  onEnter?: () => void
}

export const FlightDesignatorInput = (props: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const onChange = (value: string) => {
    // The code only allows upper case letters and numbers. We want to change any lowercase
    //  letter to uppercase and not allow other characters.
    const newCode = value.toLocaleUpperCase().replace(/[^A-Z0-9]/g, "");
    props.onChange(newCode);
  };

  const validateFlightDesignator = (newCode: string): string | boolean => {
    const isEmpty = newCode.length === 0;
    if (isEmpty) {
      return RESX.Flight.ValidFlightDesignatorFormat;
    }

    const valid = isFlightDesignatorValid(newCode);
    if (!valid) {
      return RESX.Flight.ValidFlightDesignatorFormat;
    }

    return true;
  }

  const validation = useValidate({
    key: props.validatorKey,
    title: RESX.Flight.FlightNumber,
    value: props.value,
    validate: async () => validateFlightDesignator(props.value),
    ref: inputRef,
  });

  return <>
    <InputBase
      ref={inputRef}
      focusOnMount={props.focusOnMount}
      placeholder={props.placeholderAirline ? `${props.placeholderAirline}000` : "AA000"}
      value={props.value}
      onChange={onChange}
      maxLength={serverReference.constants.flight.maxFlightDesignatorLength}
      width={60}
      error={validation.error.hasError}
      onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
    />
    {validation.error.hasError && <Message type="error">{validation.error.errorMessage}</Message>}
  </>
}
